import React from 'react'

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import _ from 'lodash';

import { maybeWithPrefix, fixedOptions, describeDate, describeTime } from '../utils';

export const describeTutor = (t, tutor_code) => {
	if(!_.isObject(t)){
		return tutor_code.trim();
	}
	
	return (
		<>
		{t.tutor_name}
		{t.email ? (<><br/>e: <a href={'mailto:'+t.email}>{t.email}</a></>) : null }
		{t.phone ? (<><br/>p: {t.phone}</>) : null}
		</>
)}

export const describeVenue = (v, venue_code) => {
	if(!_.isObject(v)){
		return venue_code.trim();
	}
						
	const suburb = (v.suburb + ' ' + v.postcode).trim();
	const contacts = _.chain([v.phone.trim(), v.mobile.trim()]).without('').join(', ').value();
				
	return (<>
		{v.name}
		{v.street ? (<><br/>{v.street}</>) : null }
		{suburb ? (<><br/>{suburb}</>) : null }
		{contacts ? (<><br/>{contacts}</>) : null }
		</>
)}

export const outputField = (title, content, isSm, classes, smGrid = 3) => {
	const smGrid2 = (smGrid === 12 ? 12 : 12 - smGrid);
	
	return (_.isEmpty(content)) ? null : (
	<Grid container item xs={12} spacing={1}>
	<Grid item xs={12} sm={smGrid} md={3}>
	<Typography variant="body1" paragraph={isSm ? true : false}>
	{title}
	</Typography>
	</Grid>
	<Grid item xs={12} sm={smGrid2} md={9}>
	<Typography variant="body1" className={classes.secondaryText} paragraph >
	{content}
	</Typography>
	</Grid>
	</Grid>
)};

export const getCourseSchedule = (course, frequency) => {
	const days = fixedOptions('days');
	const f = _.isObject(frequency) ?  frequency.description : course.frequency_code;
	
	return (
	<>
	{course.frequency_code ? (
	<>{maybeWithPrefix(course.frequency_code, f)}<br/></>
	) : null}
	Day: {days[course.day]}, {describeTime(course.start_time)} - {describeTime(course.end_time)}<br/>
	{course.start_date === course.end_date ? 
	(<>Date: {describeDate(course.start_date)}</>)
	: (<>Dates: {describeDate(course.start_date)} - {describeDate(course.end_date)} {course.next_date ? (<><br/>Next date: {describeDate(course.next_date)}</>) : null }</>)
	}
	</>
)}

